import { TriangleAlert } from 'lucide-react';
import { useApiProblem } from '@/shared/api';
import { useObjectScope } from '@/shared/object-scope';

/** Ist die Objektliste gerade nicht da (Fehler oder ohne Netz)? Dann greift keine Auswahl. */
export function useObjectListMissing(): boolean {
  const scope = useObjectScope();
  return (scope.isError || scope.isOffline) && scope.groups.length === 0;
}

/**
 * Hinweis in der Objektwahl, wenn die Liste fehlt oder veraltet ist – mit Grund des Servers und
 * einem Weg zurück. Ein Fehler darf sich nie wie „keine Objekte“ lesen.
 */
export function ObjectScopeStatus() {
  const scope = useObjectScope();
  const problem = useApiProblem(scope.error);
  if (!scope.isError && !scope.isOffline) return null;
  const stale = scope.groups.length > 0;
  const text = scope.isOffline
    ? 'Keine Verbindung – die Objektliste ist nicht geladen.'
    : stale
      ? 'Aktualisieren fehlgeschlagen – die Liste zeigt den zuletzt geladenen Stand.'
      : 'Die Objektliste kam nicht an.';
  return (
    <div
      role="alert"
      className="rounded-control bg-amber-wash mx-2 mb-2 flex gap-2 px-3 py-2 text-xs"
    >
      <TriangleAlert size={15} aria-hidden className="text-amber mt-0.5 flex-none" />
      <div className="flex flex-col gap-1">
        <span>
          {text}
          {problem?.detail ? ` ${problem.detail}` : ''}
          {!stale && scope.savedGroupId ? ' Ihre gespeicherte Auswahl greift gerade nicht.' : ''}
        </span>
        <button
          type="button"
          onClick={scope.retry}
          disabled={scope.isFetching}
          className="self-start font-bold underline underline-offset-2 disabled:no-underline"
        >
          {scope.isFetching ? 'Wird erneut geladen …' : 'Erneut laden'}
        </button>
      </div>
    </div>
  );
}
